import script from "./ShopListing.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopListing.vue?vue&type=script&setup=true&lang=js"

import "./ShopListing.vue?vue&type=style&index=0&id=5c713c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c713c3c"]])

export default __exports__